import { Product } from './product';

export const PRODUCTS: Product[] = [
  {
    title: 'Building/ Spaces',
    icon: 'fa fa-building',
    // tslint:disable-next-line:max-line-length
    imageToday: 'http://bossfight.co/wp-content/uploads/2016/10/boss-fight-free-high-quality-stock-images-photos-photography-city-street.jpg',
    imageTomorrow: 'http://www.nepbridgecompetition.co.uk/uploads/3/5/3/9/3539119/7564124_orig.jpg',
    category: '',
    today: '',
    tomorrow: '',
    next: '',
  }, {
    title: 'Food/ nutrition',
    icon: 'fa fa-apple',
    imageToday: 'https://i.pinimg.com/originals/17/28/d9/1728d955f1d506d22e5a2fe636af9d09.jpg',
    imageTomorrow: 'http://cdn.skim.gs/image/upload/v1456339679/msi/molecular-cooking_kfmp0m.jpg',
    category: '',
    today: '',
    tomorrow: '',
    next: '',
  }, {
    title: 'Mobility/ transport',
    icon: 'fa fa-subway',
    imageToday: 'https://transformingtransport.eu/sites/default/files/md-slider-image/TT_SLIDERS4.png',
    imageTomorrow: 'http://17026-presscdn-0-98.pagely.netdna-cdn.com/wp-content/uploads/sites/11/2016/09/Cross-rail-.jpeg',
    category: '',
    today: '',
    tomorrow: '',
    next: '',
  }, {
    title: 'Lifestyle',
    icon: 'fa fa-heart',
    imageToday: 'https://greatist.com/sites/default/files/running.jpg',
    imageTomorrow: 'https://www.thisiswhyimbroke.com/images/virtual-reality-gaming-treadmill2-640x533.jpg',
    category: '',
    today: '',
    tomorrow: '',
    next: '',
  }, {
    title: 'Art/ Science',
    icon: 'fa fa-flask',
    imageToday: 'https://www.asianscientist.com/wp-content/uploads/bfi_thumb/Scientist-shutterstock_114908389-30vt5bjix0ifkpir50il8g.jpg',
    imageTomorrow: 'http://edge.alluremedia.com.au/m/g/2012/10/prometheusvfx1.jpg',
    category: '',
    today: '',
    tomorrow: '',
    next: '',
  }
];



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/components/business-areas/products/products.ts